import { context } from '../../config';
import errorFormatter from '../error-formatter';
import { SafeApiError } from '../errors';
var UNAUTHORIZED = 401;
var getAxiosConfig = function getAxiosConfig(err) {
  return err instanceof SafeApiError ? err.axiosError.config : err.isAxiosError ? err.config : null;
};
var refreshInterceptor = function refreshInterceptor(axios) {
  return function (err) {
    var status = err.response ? err.response.status : err.status;
    if (status === UNAUTHORIZED && context().session) {
      var config = getAxiosConfig(err);
      if (!config) {
        Promise.reject(err);
      }
      return context().session.refreshTokens().then(function () {
        return context().session.getToken();
      }).then(function (token) {
        config.headers.Authorization = "Bearer ".concat(token);
        return config;
      }).then(function (config) {
        return axios({
          autoAuth: false
        }).then(function (baseInstance) {
          return baseInstance.request(config);
        });
      });
    }
    err.message = err instanceof SafeApiError ? err.message : errorFormatter.api(err);
    return Promise.reject(err);
  };
};
export default refreshInterceptor;